import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { FormScriptResponse } from '~/models/Commons ';
import { RootState } from '~/store/index';

interface State {
    resources: FormScriptResponse[];
}

const initialState: State = {
    resources: [],
};

const ResourceSlice = createSlice({
    name: 'resource',
    initialState,
    reducers: {
       
        DELETE_RESOURCE_BYID(state, { payload }: PayloadAction<string>) {
            const newScripts = [...state.resources].map(item =>
                item.scriptIdentify.deploymentScriptId !== payload ? item : { ...item, active: false }
            );
            state.resources = newScripts;
        },
      
    },
});

export const selectScript = (state: RootState) => state.script;

export const { DELETE_RESOURCE_BYID} =
    ResourceSlice.actions;

export default ResourceSlice.reducer;
